module.exports = __webpack_public_path__ + "img/update.e0c7cb8c.svg";